import { collectForwards } from '@bbkAdminComponents/experiences/offers/collect-forwards';
import { isLossAversionCard } from '@bbkAdminUtils/api-client/rest-cards-types';
import { type RestCard } from '@bbkAdminUtils/api-client/rest-experiences-api';
import { type RestLossAversionCard } from '@bbkAdminUtils/api-client/rest-la-cards-types';
import {
  CtaProcessingOption,
  RestModalAction,
  RestModalTemplates,
  type RestModalEmailSuccessModal,
  type RestModalForwards,
} from '@bbkAdminUtils/api-client/rest-modals-cards-types';

type LaConfirmation =
  | { status: 'none' | 'invalid' }
  | {
      status: 'ready';
      offerCard: RestLossAversionCard;
      offerCta: RestModalForwards;
      confirmationModal: RestModalEmailSuccessModal;
    };

export const LA_CONFIRMATION_UNAVAILABLE =
  'The confirmation modal is unavailable. Please try again later.';

// A dedicated confirmation has exactly one incoming CTA, which owns its
// processing identity.
export const resolveLaConfirmation = (
  cards: RestCard[],
  name?: string
): LaConfirmation => {
  if (!name) return { status: 'none' };
  const owners = cards.flatMap((card) =>
    collectForwards(card)
      .filter(({ value }) => value?.modal === name)
      .map(({ value: cta }) => ({ card, cta }))
  );
  if (
    !owners.some(
      ({ cta }) => cta.action === RestModalAction.open_offer_confirmation
    )
  )
    return { status: 'none' };
  const owner = owners[0];
  const targets = cards.filter((card) => card.name === name);
  const modal = targets[0];
  if (
    owners.length !== 1 ||
    !owner ||
    !isLossAversionCard(owner.card) ||
    owner.cta.cta_details_list?.some(
      (details) =>
        details.processing_option === CtaProcessingOption.chargebee_checkout
    ) ||
    targets.length !== 1 ||
    modal?.template !== RestModalTemplates.modal_email_success ||
    modal.requires?.forwards?.action !== RestModalAction.link
  )
    return { status: 'invalid' };
  return {
    status: 'ready',
    offerCard: owner.card,
    offerCta: owner.cta,
    confirmationModal: modal,
  };
};
